import type { AddressRequestRow } from '../../api/types';

type Kind = 'REGISTERED' | 'BILLING' | 'SHIPPING';

/** The latest request for this address (or, for a first address of a kind, for that kind). */
export function latestRequest(rows: readonly AddressRequestRow[], kind: Kind, addressId: string | null) {
  return rows.find((r) => (addressId ? r.addressId === addressId : r.addressId === null && r.kind === kind));
}


const ROWS = [
  ['contactName', 'shop.account.addrContact'], ['line1', 'shop.account.addrLine1'], ['line2', 'shop.account.addrLine2'],
  ['city', 'shop.account.addrCity'], ['postalCode', 'shop.account.addrPostal'], ['countryCode', 'shop.account.addrCountry'],
  ['contactPhone', 'shop.account.addrPhone'],
] as const;

/** The requested address as label / value pairs — only the fields that were filled in, each under its own name. */
export function proposedRows(
  proposed: AddressRequestRow['proposed'], t: (key: string) => string,
): Array<[string, string]> {
  if (!proposed) return [];
  return ROWS.filter(([k]) => !!proposed[k]).map(([k, label]) => [t(label), proposed[k] as string]);
}
